/**
 * Returns a short, human-friendly relative timestamp.
 *  - <60s  -> "12s ago"
 *  - <60m  -> "7m ago"
 *  - <24h  -> "3h ago"
 *  - else  -> "Mar 14, 09:12"
 */
export function relativeTime(isoString) {
  if (!isoString) return "—";
  const then = new Date(isoString).getTime();
  if (Number.isNaN(then)) return "—";
  const diff = Math.max(0, Date.now() - then);
  const s = Math.floor(diff / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = new Date(isoString);
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function ageFromIso(isoString) {
  if (!isoString) return null;
  const then = new Date(isoString).getTime();
  if (Number.isNaN(then)) return null;
  return Math.max(0, Math.floor((Date.now() - then) / 1000));
}

/**
 * Tailwind class fragments per semantic state.
 *  ok       -> green   (in range, fresh)
 *  warn     -> amber   (active warn alert)
 *  critical -> red     (active critical alert)
 *  stale    -> yellow  (no data >5 min)
 *  no_data  -> grey    (no readings yet)
 */
export const STATE_STYLES = {
  ok: {
    border: "border-emerald-500/80",
    text: "text-emerald-400",
    bg: "bg-emerald-500/10",
    pill: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
    label: "OK",
  },
  warn: {
    border: "border-amber-500/80",
    text: "text-amber-400",
    bg: "bg-amber-500/10",
    pill: "bg-amber-500/15 text-amber-200 border-amber-500/40",
    label: "WARN",
  },
  critical: {
    border: "border-red-500/80",
    text: "text-red-400",
    bg: "bg-red-500/10",
    pill: "bg-red-500/20 text-red-200 border-red-500/50",
    label: "CRITICAL",
  },
  stale: {
    border: "border-yellow-600/70",
    text: "text-yellow-500",
    bg: "bg-yellow-600/10",
    pill: "bg-yellow-600/15 text-yellow-300 border-yellow-600/40",
    label: "STALE",
  },
  no_data: {
    border: "border-zinc-600",
    text: "text-zinc-400",
    bg: "bg-zinc-700/10",
    pill: "bg-zinc-700/40 text-zinc-300 border-zinc-600",
    label: "NO DATA",
  },
};
